<script setup lang="ts">
import { useSurfaceDraftsStore } from '@@/pinia/surface_drafts'
import { DropZone, useSurfaceDragAndDropEventsStore } from '@@/pinia/surface_drag_and_drop_events_store'
import { useDropToCreatePost } from '@@/vuecomposables/useDropToCreatePost'
import { storeToRefs } from 'pinia'

const { isHandlingDragEvent, dropActionMessage, activeDropZone } = storeToRefs(useSurfaceDragAndDropEventsStore())
const { isAnyDraftActive } = storeToRefs(useSurfaceDraftsStore())

useDropToCreatePost()
</script>

<template>
  <!-- When there's an active post composer modal, it will take care of styling the drop overlay. -->
  <!-- We don't need to render this component. -->
  <Transition name="fade">
    <div
      v-if="isHandlingDragEvent && dropActionMessage && activeDropZone === DropZone.DOCUMENT && !isAnyDraftActive"
      :class="[
        'fixed',
        'inset-0',
        'z-dragging-overlay',
        'bg-grape-500/50 dark:bg-canary-500/[0.35]',
        'will-change-[background-color]',
        'pointer-events-none',
      ]"
    >
      <div
        :class="[
          'absolute',
          'top-5',
          'inset-x-0',
          'rounded-lg',
          'shadow-elevation-3',
          'mx-auto',
          'w-fit',
          'px-3',
          'py-2',
          'bg-light-ui-100 dark:bg-dark-ui-100',
        ]"
      >
        <p
          :class="[
            'text-body-extra-small',
            'font-sans',
            'text-center',
            'text-dark-text-100 dark:text-light-text-100',
            'break-words',
          ]"
        >
          {{ dropActionMessage }}
        </p>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.fade-enter,
.fade-leave-to {
  @apply bg-grape-500/0 dark:bg-canary-500/0;
}

.fade-enter-to,
.fade-leave {
  @apply bg-grape-500/50 dark:bg-canary-500/[0.35];
}

.fade-enter-active {
  @apply duration-180 ease-out;
}

.fade-leave-active {
  @apply duration-180 ease-in;
}
</style>
